export default __webpack_public_path__ + "static/media/ChasingActivityImage2.dc20e1cb.png";